import React from 'react'
import '../../base/Theme.css';
import './LobbyItem.css';
import Text from "../../base/text/Text";
import {formatValue} from "../../../utils/Formatter";

function LobbyItem({table, onClick, highlight}) {

    let className = "LobbyItem";
    if (highlight) className += " LobbyItemHighlighted";

    return (
        <li key={table.id} className={className} onClick={() => {
            onClick(table)
        }}>
            <Text style={"TextAlignLeft"} text={table?.name}/>
            <Text style={"TextAlignCenter"}
                  text={formatValue(table?.smallBlind, "") + "/" + formatValue(table?.bigBlind)}/>
            <Text style={"TextAlignRight"} text={table?.playersNumber + "/" + table?.seatsNumber + " players"}/>
        </li>
    );
}

export default LobbyItem;
